import Vue from 'vue'
import Vuex from 'vuex'

import * as firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'

// import { freeVersion, plansScalesLimit } from '@/constants'

import { processUserGroupCapabilities, processGroupLocations, buildGroupObject, valueToTime } from '@/functions'

import { apiFetchAuthenticatedUserCapabilities } from '@/services/users'

import router from './router'

import groupplaceholder from '@/assets/images/groupplaceholder.png'
import userProfileBroken from '@/assets/images/user-profile-broken.png'

import { /* apiGetCurrentUser, */ getUserByID, getScaleByID, getGroupByID, apiRefOpen, apiRefClose } from '@/services/firebase'
import { processUserProfile, processGroupUserProfile, isValidImage, firstLastName, timeToFloat, formatMoney, formatFloatToScaleDuration, durationToFactor } from '@/mixins/utils'

import moment from 'moment'
import 'moment/locale/pt-br'
moment.locale('pt-BR')

//
// CAPACIDADES DO USUÁRIO
//

const getUserCapabilities = async args => {
  const response = await apiFetchAuthenticatedUserCapabilities({ firebase_id: args.userID }, args.userToken)

  if (response.httpCode !== 200 || response.code !== 1) return { code: 'ERROR_PROFILE_API', message: '', plans: [] }

  if (
    !!response.message.userPlans === false || (
      !!response.message.userPlans === true &&
      response.message.userPlans.code === 0
    )
  ) return { code: 'ERROR_PLANS_API', message: '', plans: [] }

  return {
    code: 1,
    message: response.message,
    plans: Array.isArray(response.message.userPlans.plans) ? response.message.userPlans.plans : [],
  }
}

const buildUserSessionObject = () => {
  return {
    loading: true,

    authState: 'WAITING',

    loggedIn: false,
    uid: '',
    // displayName: '',
    email: '',
    userToken: '',

    userProfile: { img: userProfileBroken, nome: '', email: '', ddd: '', tel: '', phone: '', cpf: '', cnpj: '', crm: '', conta: '', capsLock: false },

    userGroupsAmount: 0,

    //
    // SENHOR JESUS - Continuar aqui e também voltar para o state.user =
    //

    planId: 0, // Number
    planName: { name: 'Plano Grátis', desconto: false, recorrencia: false },
    planCategory: 'free',
    planOrigin: '',
    userCapabilities: {
      limiteEscalas: 1,
      limiteUsuarios: 15,
      limiteUsuariosDefault: 15,
      editorUsuarios: false,
      folhaPagamento: false,
      relatorioEscala: false,
      relatorioHoras: false,
      folhaDePonto: false,
      relacionarEscalas: false,
      planManager: false,
    },

    vindi: {
      // --------------------------- APENAS VINDI ---------------------------
      paymentStatus: '',
      paymentUrl: '',
      // --------------------------- APENAS VINDI ---------------------------

      isActive: false,
      planOrigin: 'VINDI',

      planId: 0,
      planName: { name: 'Plano Grátis', desconto: false, recorrencia: false },
      planCategory: 'free',
      planExpirationDate: false,
      capabilities: {
        limiteEscalas: 1,
        limiteUsuarios: 15,
        limiteUsuariosDefault: 15,
        editorUsuarios: false,
        folhaPagamento: false,
        relatorioEscala: false,
        relatorioHoras: false,
        folhaDePonto: false,
        relacionarEscalas: false,
        planManager: false,
      },
    },

    coupon: {
      isActive: false,
      planOrigin: 'COUPON',

      planId: 0,
      planName: { name: 'Plano Grátis', desconto: false, recorrencia: false },
      planCategory: 'free',
      planExpirationDate: false,
      capabilities: {
        limiteEscalas: 1,
        limiteUsuarios: 15,
        limiteUsuariosDefault: 15,
        editorUsuarios: false,
        folhaPagamento: false,
        relatorioEscala: false,
        relatorioHoras: false,
        folhaDePonto: false,
        relacionarEscalas: false,
        planManager: false,
      },
    },

    groups: {},
  }
}

const buildRequestedShiftObj = (dutyCreatorProfile, waitingDutyID, waitingDuty, dutyScale, currentID) => {
  const userName = !!dutyCreatorProfile.nome === true && String(dutyCreatorProfile.nome).trim().length > 0 ? String(dutyCreatorProfile.nome).trim() : ''
  const dutyCreatorName = userName ? firstLastName(userName) : ''

  const ddd = dutyCreatorProfile.ddd ? String(dutyCreatorProfile.ddd).trim() : ''
  const phone = dutyCreatorProfile.tel ? String(dutyCreatorProfile.tel).trim() : ''
  const telefone = ddd.length === 2 && (phone.length === 8 || phone.length === 9) ? ('(' + ddd + ') ' + (phone.length === 8 ? phone.replace(/(\d{4})(\d{4})/, '$1-$2') : phone.replace(/(\d{5})(\d{4})/, '$1-$2'))) : ''

  // DETALHES DA ESCALA APLICADO AO PLANTÃO (obs: se a escala não existir, será aplicado nome do plantão no momento da criação + valor 0)

  const dutyScaleName = !!dutyScale.type === true && typeof dutyScale.type === 'string' && dutyScale.type.trim().length > 0 ? dutyScale.type : waitingDuty.dutyName

  //

  // const dutyWeekDay = moment(waitingDuty.dutyDate, 'YYYY-MM-DD').day()
  // const dutyDay = moment(waitingDuty.dutyDate, 'YYYY-MM-DD').format('DD')
  // const dutyDateFilter = moment(waitingDuty.dutyDate, 'YYYY-MM-DD').format('YYYY/MM')

  const dutyWaitingListDate = moment(`${waitingDuty.dutyDate} ${waitingDuty.dutyTime}:00`, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY [às] HH:mm')
  const dutyWaitingListDateCompare = moment(`${waitingDuty.dutyDate} ${waitingDuty.dutyTime}:00`, 'YYYY-MM-DD HH:mm:ss').unix()

  const dutyDurationFmt = formatFloatToScaleDuration(waitingDuty.dutyDuration)
  const dutyDurationFactor = durationToFactor(waitingDuty.dutyDuration)

  const dutyValue = waitingDuty.dutyValue || 0

  let dutyCalculatedValue = 0
  let dutyScaleValue = 0

  if (waitingDuty.dutyStatus !== 0 && waitingDuty.dutyStatus !== '0') {
    dutyScaleValue = waitingDuty.dutyScaleValue || 0 // corrigir um bug gerado por não incluir data.duty no "api Set Waiting Duty Status" (/src/views/new/scales/Group.vue)
    dutyCalculatedValue = waitingDuty.dutyValue
  } else {
    dutyScaleValue = dutyScale.value || 0

    if (dutyScaleValue > 0 && dutyDurationFactor > 0) {
      dutyCalculatedValue = dutyScaleValue * dutyDurationFactor
    } else {
      dutyCalculatedValue = dutyValue
    }
  }

  const dutyScaleValueFmt = formatMoney(dutyScaleValue)
  const dutyCalculatedValueFmt = formatMoney(dutyCalculatedValue)

  return !!dutyCreatorProfile === false ? false : {
    waitingDutyID,

    dutyCreatorID: waitingDuty.dutyCreatorID,
    dutyCreatorImageIsValid: isValidImage(dutyCreatorProfile.img || ''),
    dutyCreatorImage: isValidImage(dutyCreatorProfile.img || '') ? String(dutyCreatorProfile.img).trim() : userProfileBroken,
    dutyCreatorName,
    dutyCreatorPhone: telefone,
    isMe: waitingDuty.dutyCreatorID === currentID,

    dutyDateTimestamp: waitingDuty.dutyDateTimestamp,
    dutyDate: waitingDuty.dutyDate,
    dutyTime: waitingDuty.dutyTime,

    dutyDuration: waitingDuty.dutyDuration,
    dutyDurationFmt,

    dutyValue,

    dutyGroupID: waitingDuty.dutyGroupID,
    dutyScaleID: waitingDuty.dutyScaleID,

    dutyName: dutyScaleName,
    dutyPlace: waitingDuty.dutyPlace || 'Não definido',
    dutyStatus: waitingDuty.dutyStatus,
    dutyType: waitingDuty.dutyType,

    // src/views/new/scales/Group.vue
    dutyWaitingListDate,
    dutyScaleValue,
    dutyScaleValueFmt,
    dutyCalculatedValue,
    dutyCalculatedValueFmt,

    // store.js
    dutyWaitingListDateCompare,
  }
}

//
// ESCALAS DO GRUPO
//

const processGroupScales = scales => {
  // Quantidade de plantonistas no grupo
  const groupPlantonistas = []

  const escalas = scales.map(([scaleID, scale]) => {
    const scaleTurnos = []
    const scalePlantonistas = []

    const scaleRawTurns = !!scale.turnos === true ? Object.entries(scale.turnos) : []

    if (scaleRawTurns.length > 0)
    {
      scaleRawTurns.forEach(([turnoID, turno]) => {
        const turnStartDecimal = timeToFloat(turno.hour)
        const turnStart = valueToTime(turno.hour)

        //
        // TURNO
        //

        const turnoJaInserido = scaleTurnos.findIndex(turnOnScale => turnOnScale.turnStartDecimal === turnStartDecimal)

        if (turnoJaInserido === -1) scaleTurnos.push({ turnID: turnoID, turnType: turnStartDecimal < 19 ? 'daytime' : 'night', turnStart, turnStartDecimal, turnDuration: turno.duration, turnValue: turno.value })

        //
        // CALCULA A QUANTIDADE DE PLANTONISTAS NA ESCALA (EDITAR ESCALA)
        //

        const rawTurnDuties = !!turno.plantoes === true ? Object.entries(turno.plantoes) : []

        if (rawTurnDuties.length > 0)
        {
          rawTurnDuties.forEach(([_, plantao]) => {
            const rawTurnDuties = !!plantao.users === true ? Object.entries(plantao.users) : []

            if (rawTurnDuties.length > 0)
            {
              rawTurnDuties.forEach(([_, shiftUser]) => {
                // Plantonistas na escala
                if (!!shiftUser.uid === true && scalePlantonistas.indexOf(shiftUser.uid) === -1) scalePlantonistas.push(shiftUser.uid)

                // Plantonistas no grupo
                if (!!shiftUser.uid === true && groupPlantonistas.indexOf(shiftUser.uid) === -1) groupPlantonistas.push(shiftUser.uid)
              })
            }
          })
        }
      })
    }

    scaleTurnos.sort((a, b) => a.turnStartDecimal - b.turnStartDecimal)

    const scaleLocationName = String(scale.local || '').trim()

    return {
      scaleID,
      scaleName: String(scale.type || '').trim(),
      scaleLocationStatus: scaleLocationName.length > 0 ? 'OK' : 'EMPTY',
      scaleLocation: {
        id: String(scale.placeID || ''),
        name: scaleLocationName,
      },
      scalePlantonistas: scalePlantonistas.length,
      scaleTurnos,
      scaleValue: scale.value || 0, // SENHOR JESUS (Possível bug?)
      scaleValueFormatted: formatMoney(scale.value || 0), // SENHOR JESUS (Possível bug?)
      scaleMaxShifts: !!scale.maxshifts === true ? Number(scale.maxshifts) : 0,
      startOnMonday: !!scale.startOnMonday === true,
      availableShiftsColor: scale.availableShiftsColor || '#00cb72',
      ownedShiftsColor: scale.ownedShiftsColor || '#2196f3',
      scaleUsers: !!scale.users === true ? scale.users : null,
      scaleCode: String(scale.urlcode || ''),
      scaleRelatedUsers: !!scale.relatedUsers === true ? Object.keys(scale.relatedUsers) : [],

      // [master-portaltelemedicina]
      // scaleConsultationDuration: String(scale.tempo_consulta || 0),
      // requirePatient: !!scale === true && !!scale.requirePatient === false,
    }
  })

  return { groupScales: escalas, numberOfPlantonistasOnGroup: groupPlantonistas.length }
}

//
// LOCAIS DO GRUPO
//

const processGroupSettings = (groupID, group) => {
  const g = group

  g.groupID = groupID

  g.groupImage = isValidImage(g.img || '') ? String(g.img).trim() : groupplaceholder
  g.groupName = String(g.nome || '').trim() // 18/03/2024 - ADICIONADO PARA INJETAR DADOS NECESSÁRIOS NO "EDITAR DETALHES DO GRUPO" DENTRO DA TELA DO GRUPO
  g.groupDescription = String(g.des || '').trim() // 18/03/2024 - //
  g.groupCnpj = String(g.cnpj || '').trim() // 18/03/2024 - //

  g.presetLocations = g.fixLocais // 18/03/2024 - //
  g.groupLocations = processGroupLocations(g)

  g.allowCreateDuty = g.allowCreateDuty || false // 18/03/2024 - //
  g.allowPassDuty = g.allowPassDuty || false // 18/03/2024 - //
  g.startShiftOnDayOnly = g.startShiftOnDayOnly || false // 24/06/2024 - //
  g.allowPauseDuringShift = g.allowPauseDuringShift || false // 24/06/2024 - //
  g.disableShiftStart = g.disableShiftStart || false // 24/06/2024 - //
  g.disableShiftEnd = g.disableShiftEnd || false // 24/06/2024 - //
  g.remindShiftStart = g.remindShiftStart || false // 26/06/2024 - //
  g.hideDutyValue = g.hideDutyValue || false // 18/03/2024 - //
  g.hideGroupShiftsTab = g.hideGroupShiftsTab || false // 17/07/2024 - //

  g.approvePassDuty = g.approvePassDuty || false // 18/03/2024 - //
  g.whoCanAcceptOrRefuse = !!g.approvePassDuty === true && !!g.whoCanAcceptOrRefuse === true && g.whoCanAcceptOrRefuse === 'apenas_gestores' // 25/03/2024 - NOVA OPÇÃO NO GRUPO

  g.allowDutyCandidates = g.allowDutyCandidates || false // 18/03/2024 - ADICIONADO PARA INJETAR DADOS NECESSÁRIOS NO "EDITAR DETALHES DO GRUPO" DENTRO DA TELA DO GRUPO
  g.disablePassToGroupAndUser = g.disablePassToGroupAndUser || false // 18/03/2024 - //
  g.disablePassToGroup = g.disablePassToGroup || false // 18/03/2024 - //
  g.sequentialShiftConflicts = g.sequentialShiftConflicts || false // 18/03/2024 - //
  g.sequentialShiftConflictsInterval = g.sequentialShiftConflictsInterval ? g.sequentialShiftConflictsInterval : '60' // 18/03/2024 - //

  g.superAdminGroupDeleteFlag = g.superAdminGroupDeleteFlag || false

  g.groupUsers = g.users || {} // 18/03/2024 - ADICIONADO PARA INJETAR DADOS NECESSÁRIOS NO "EDITAR DETALHES DO GRUPO" DENTRO DA TELA DO GRUPO

  // g.groupInviteID = g.idconvite ? g.idconvite.trim() : ''
  g.groupShareCode = String(g.urlcode || '')

  return g
}

//
//
//

Vue.use(Vuex)

//
//
//

const store = new Vuex.Store({
  //
  // GLOBAL STATE
  //

  state: {
    strict: process.env.NODE_ENV !== 'production',

    // CACHE
    cachedUsers: [],

    // EDITOR DE USUÁRIOS
    managerUsers: [],

    // DIALOGS
    dialogLogout: false,

    loadingUsers: 'WAITING',
    loadingUsersProgress: 0,
    loadingUsersMax: 0,

    groups: [],
    loadingGroups: 'WAITING',
    loadingGroupsProgress: 0,

    loadingGroupStatistics: 'WAITING',
    numberOfAvailableDutys: 0,

    groupScales: [],
    groupUsers: [],
    groupRequestedShifts: [],

    currentGroupCapabilities: processUserGroupCapabilities(null, null),

    group: {
      // groupID: '',
      loading: true,
      nome: '',
      users: {},
    },

    // groupShifts: [],

    listeners: {
      /*  */
      groups: [],

      /*  */
      user: null,
      onUserUpdate: null,

      /*  */
      groupRequestedShiftsRef: null,
      groupRef: null,
      groupScalesRef: null,

      /*  */
      onGroupRequestedShiftsUpdate: null,
      onGroupUpdate: null,
      onGroupScalesUpdate: null,

      /*  */
      // groupShifts: [],

      /* the group itself */
      loadingGroupDetails: 'WAITING',

      /* statistics */
      availableShiftsCount: 0,
      ownedShiftsCount: 0,
      participantsCount: 0,
      numberOfPlantonistasOnGroup: 0,

      /* group waiting duties */
      loadingRequestedShifts: 'yes',

      /* group scales */
      loadingGroupScales: 'yes',
      groupScales: [],
    },

    groupCreationStep: 'options_invite',
    users: [],

    EditScale: {
      jornada: 'Manual',
      journeyWorkingDays: '',
      journeyDaysOff: '',
      weeks: [],
      ctrl_z: {
        // type: '',
        data: [],
      },
    },

    userSession: buildUserSessionObject(),

    drawer: null,
    plans: [],
  },

  //
  //
  //
  //
  // GETTERS
  //
  // Os "getters" são usados para acessar e calcular valores derivados do estado da loja.
  // Eles são semelhantes a propriedades computadas em componentes Vue, mas para o estado global da aplicação gerenciado pelo Vuex.
  // Os "getters" são úteis quando você precisa de uma forma de acessar ou filtrar os dados da loja de uma maneira reutilizável.
  //
  //
  //
  //

  getters: {
    getUserById: state => id => {
      return !!state.managerUsers === true && Array.isArray(state.managerUsers) ? state.managerUsers.find(profile => profile.userID === id) : false
    },

    getCachedUserById: state => id => {
      return !!state.cachedUsers === true && Array.isArray(state.cachedUsers) ? state.cachedUsers.find(profile => profile.userID === id) : false
    },

    getGroupById: state => id => {
      return !!state.groups === true && Array.isArray(state.groups) ? state.groups.find(group => group.groupID === id) : false
    },

    numberOfPlantonistasOnGroup: state => {
      return state.listeners.numberOfPlantonistasOnGroup
    },
  },

  //
  //
  //
  //
  // MUTATIONS
  //
  // As "mutations" são responsáveis por modificar o estado da loja de forma síncrona.
  // Elas são usadas para realizar alterações diretas no estado da aplicação.
  // As "mutations" são chamadas a partir das "actions" e são o único modo de alterar o estado do Vuex.
  // Isso garante que todas as alterações no estado sejam rastreáveis e previsíveis.
  //
  //
  //
  //

  mutations: {
    /* Available duties */

    SET_GROUP_AVAILABLE_DUTIES_AMOUNT: (state, payload = 0) => {
      // [24/01/25] console.log('::: SET_GROUP_AVAILABLE_DUTIES_AMOUNT:', payload)

      state.numberOfAvailableDutys = payload
      state.loadingGroupStatistics = 'DONE'
    },

    SET_GROUP_AVAILABLE_DUTIES_AMOUNT_STATUS: (state, payload = 'WAITING') => {
      // [24/01/25] console.log('::: SET_GROUP_AVAILABLE_DUTIES_AMOUNT_STATUS:', payload)

      state.loadingGroupStatistics = payload
    },

    /* Group */

    SORT_GROUP_USERS: (state) => {
      // [24/01/25] console.log('::: ORDENANDO LISTA DE PARTICIPANTES')

      // isMe: userID === currentID,

      const currentID = !!state.userSession === true && !!state.userSession.uid === true ? state.userSession.uid : false

      // JESUS > Bug antigo: Pode acontecer do userSession carregar depois do grupo e por isso a lista não é reordenada corretamente

      if (state.groupUsers.length > 0) {
        state.groupUsers.sort((a, b) => {
          const isMeA = a.userID === currentID
          const isMeB = b.userID === currentID
          // Compare by isMe first
          if (isMeA && !isMeB) return -1
          if (!isMeA && isMeB) return 1
          // If both have the same isMe value, compare by userName
          return a.userName.localeCompare(b.userName)
        })
      }
    },

    SET_GROUP_USERS: (state, payload = {}) => {
      // [24/01/25] console.log(`::: [${payload.groupID}] [onGroupUpdate] LISTA DE PARTICIPANTES`, payload.users.length)

      state.listeners.participantsCount = payload.users.length

      state.groupUsers = payload.users
    },

    SET_GROUP_WAITING_DUTIES: (state, payload = []) => {
      // [24/01/25] console.log('::: [onGroupRequestedShiftsUpdate] LISTA DE PLANTÕES SINALIZADOS:', payload.length)

      state.listeners.loadingRequestedShifts = 'no'
      state.groupRequestedShifts = payload
    },

    SET_GROUP: (state, payload = {}) => {
      // [24/01/25] console.log(`::: [${payload.groupID}] [onGroupUpdate] GRUPO ATUALIZADO`)

      const userGroups = !!state.userSession === true && !!state.userSession.groups === true ? state.userSession.groups : null

      state.group = { loading: false, ...payload }
      state.currentGroupCapabilities = processUserGroupCapabilities(userGroups, payload.groupID)

      // [24/01/25] console.log(`::: [${payload.groupID}] [onGroupUpdate] GRUPO ATUALIZADO > currentGroupCapabilities:`, state.currentGroupCapabilities)
    },

    CLEAR_GROUP: (state) => {
      state.groupUsers = []
      state.listeners.loadingGroupDetails = 'WAITING'
      state.numberOfAvailableDutys = 0
      state.loadingGroupStatistics = 'WAITING'

      state.group = { /* groupID: '', */ loading: true, nome: '', users: {} }
      state.currentGroupCapabilities = processUserGroupCapabilities(null, null)

      // [24/01/25] console.log('::: CLEAR_GROUP > currentGroupCapabilities:', state.currentGroupCapabilities)
    },

    /* Group statistics */

    SET_GROUP_STATISTICS: (state, statistics = { availableShiftsCount: 0, ownedShiftsCount: 0, participantsCount: 0 }) => {
      state.listeners.availableShiftsCount = statistics.availableShiftsCount || state.listeners.availableShiftsCount
      state.listeners.ownedShiftsCount = statistics.ownedShiftsCount || state.listeners.ownedShiftsCount
      state.listeners.participantsCount = statistics.participantsCount || state.listeners.participantsCount
    },

    /* Users */

    ADD_CACHED_USER: (state, user) => {
      // console.log('::: ADD_CACHED_USER:', user)

      state.cachedUsers.push(user)
    },

    /* Edit scale */

    SET_EDIT_SCALE_CTRL_Z (state, payload = {}) {
      if (
        !!payload.type === true &&
        !!payload.data === true &&
        (
          (payload.type === 'add' && Array.isArray(payload.data) && payload.data.length > 0) ||
          (payload.type === 'remove' && typeof payload.data === 'string' && payload.data.length > 0) ||
          (payload.type === 'removemany' && Array.isArray(payload.data) && payload.data.length > 0)
        )
      ) {
        // state.EditScale.ctrl_z.type = payload.type

        if (payload.type === 'add') {
          // faz uma cópia do state atual
          const newRecords = state.EditScale.ctrl_z.data !== null ? state.EditScale.ctrl_z.data : []

          // acrescenta novos plantões na cópia
          payload.data.forEach(path => {
            newRecords.push(path)
          })

          // substitui o state pela cópia
          state.EditScale.ctrl_z.data = newRecords
        } else if (payload.type === 'remove') {
          const currentPaths = state.EditScale.ctrl_z.data !== null ? state.EditScale.ctrl_z.data : []
          state.EditScale.ctrl_z.data = currentPaths.length > 0 ? currentPaths.filter(item => item !== payload.data) : []
        } else if (payload.type === 'removemany' && Array.isArray(payload.data) && payload.data.length > 0) {
          const currentPaths = state.EditScale.ctrl_z.data !== null ? state.EditScale.ctrl_z.data : []
          state.EditScale.ctrl_z.data = currentPaths.length > 0 ? currentPaths.filter(item => payload.data.indexOf(item.split('/users/')[0]) === -1) : []
        }
      }
    },

    CLEAR_EDIT_SCALE_CTRL_Z (state) {
      // state.EditScale.ctrl_z.type = ''
      state.EditScale.ctrl_z.data = []
    },

    SET_WORKINGDAY (state, status = 'Manual') {
      state.EditScale.jornada = status

      // console.log('::: SET_WORKINGDAY:', state.EditScale, status)
    },

    SET_WORKINGDAYSAMOUNT (state, journeyWorkingDays = '') {
      state.EditScale.journeyWorkingDays = journeyWorkingDays

      // console.log('::: SET_WORKINGDAYSAMOUNT:', state.EditScale, journeyWorkingDays)
    },

    SET_DAYSOFFAMOUNT (state, journeyDaysOff = '') {
      state.EditScale.journeyDaysOff = journeyDaysOff

      // console.log('::: SET_DAYSOFFAMOUNT:', state.EditScale, journeyDaysOff)
    },

    SET_WEEKS (state, weeks = []) {
      state.EditScale.weeks = weeks
    },

    /* Navigation */

    SET_DRAWER (state, payload) {
      state.drawer = payload
    },

    ASK_LOGOUT (state, payload = true) {
      // console.log('::: ASK_LOGOUT:', payload)
      state.dialogLogout = payload
    },

    /* Undefined */

    setPlans (state, payload) {
      state.plans = payload
    },

    CLEAR_USER_MANAGER: (state, loading) => {
      state.managerUsers = []
      state.loadingUsers = loading
      state.loadingUsersProgress = 0
      state.loadingUsersMax = 0
    },

    CLEAR_USER_PROFILE: state => {
      state.userSession = buildUserSessionObject()
    },

    SET_USER_GROUPS_STATUS: (state, loadingStatus) => {
      // console.log('::: SET_USER_GROUPS_STATUS:', loadingStatus)

      state.loadingGroups = loadingStatus

      // CHAMADO APENAS NO 'WAITING', ENTÃO O PROGRESSO PODE E DEVE SER 0
      state.loadingGroupsProgress = 0
    },

    CLEAR_USER_GROUPS: (state, loadingStatus) => {
      if (state.listeners.groups.length > 0) {
        state.listeners.groups.map(groupListener => {
          if (groupListener.groupID) {
            // console.log('::: CLEAR_USER_GROUPS:', groupListener.groupID, groupListener.ref, groupListener.listener)
            apiRefClose(groupListener.ref, groupListener.listener)
          }
        })
      }

      state.listeners.groups = []

      state.groups = []
      state.loadingGroups = loadingStatus
      state.loadingGroupsProgress = 0
    },

    SET_SCREEN_GROUPS: (state, groups) => {
      if (groups.length > 0) groups.sort((a, b) => a.groupName.localeCompare(b.groupName))
      state.groups = groups

      // SENHOR JESUS
      // console.log(':::: GRUPOS COLOCADOS NA TELA:', sorted.map(group => `(${group.groupID}) ${group.groupName}`))
    },

    UPDATE_GROUP_ITEM: (state, group) => {
      const groupExists = state.groups.findIndex(findGroup => findGroup.groupID === group.groupID)

      if (groupExists === -1)
      {
        // ADICIONA ITEM NA LISTA DE GRUPOS
        state.groups.push(group)
      }
      else
      {
        // FORÇA UMA ATUALIZAÇÃO DO ITEM
        state.groups.splice(groupExists, 1)
        state.groups.push(group)

        // console.log('::: LISTA DE GRUPOS > ATUALIZAÇÃO:', group.groupID, group.groupName, group.groupDescription)
      }

      // DEBUG
      // console.log(`::: LISTA DE GRUPOS > ${groupExists === -1 ? 'NOVO GRUPO' : 'ATUALIZAÇÃO'}:`, group.groupID, group.groupName)

      // ORDENA OS ITEMS NOVAMENTE
      if (state.groups.length > 0) state.groups.sort((a, b) => a.groupName.localeCompare(b.groupName))
    },
  },

  //
  //
  //
  //
  // ACTIONS
  //
  // As "actions" são usadas para realizar operações assíncronas ou complexas e, em seguida, chamar as "mutations" para efetuar as alterações no estado.
  // Elas fornecem uma maneira de separar a lógica de negócios das "mutations", mantendo as "mutations" responsáveis apenas por modificar o estado.
  // As "actions" são chamadas a partir dos componentes Vue usando store.dispatch('actionName').
  //
  //
  //
  //

  actions: {
    //
    //
    //

    async setAuthState ({ dispatch, commit, state, getters }, argSession)
    {
      //
      // TRATAMENTOS
      //

      const wasLoggedIn = !!state.userSession.loggedIn === true
      const isLoggedIn = argSession.authenticated === true

      const isGuest = wasLoggedIn === false && isLoggedIn === false
      const userLeave = wasLoggedIn === true && isLoggedIn === false
      const userJoin = wasLoggedIn === false && isLoggedIn === true

      //
      // DADOS ÚTEIS
      //

      const sessionEmail = argSession.authenticated === true ? argSession.email : ''
      const sessionUserID = argSession.authenticated === true ? argSession.uid : ''
      const sessionOrigin = argSession.sosOrigin
      const userToken = argSession.authenticated === true ? (!!argSession.token === true ? argSession.token : await argSession.user.getIdToken()) : ''

      // TRATAMENTOS

      if (wasLoggedIn === isLoggedIn && sessionOrigin === 'STATE') {
        // console.log(`[${sessionOrigin}] setAuthState: NÃO HOUVE MUDANÇA NO STATUS DA SESSÃO`)
        return false
      }

      if (state.userSession.authState === 'LOADING') {
        // console.log(`[${sessionOrigin}] setAuthState: JÁ FOI PROCESSADO`)
        return false
      }

      // console.log(`[${sessionOrigin}] setAuthState: PROCESSANDO...`)

      state.userSession.authState = 'LOADING'

      /**
       *
       *
       *
       * AJUSTES PARA USUÁRIO DESLOGADO
       *
       *
       *
       */

      if (isGuest)
      {
        // console.log(`[${sessionOrigin}] setAuthState: isGuest`)

        state.userSession.loading = false
        state.userSession.authState = 'DONE'
      }

      /**
       *
       *
       *
       * LIMPA A SESSÃO DO USUÁRIO APÓS O LOGOUT
       *
       *
       *
       */

      else if (userLeave)
      {
        // console.log(`[${sessionOrigin}] setAuthState: userLeave`)

        // if (wasLoggedIn) {
          // console.log(`::: [${state.userSession.email}] O USUÁRIO "${state.userSession.uid}" SAIU DO GESTOR`)
        // } else {
          // console.log('::: CARREGOU A TELA COM SEM UMA SESSÃO ATIVA')
        // }

        dispatch('loadGroupPage', 'clear')
        dispatch('clearUserGroups', 'LEAVING')
        dispatch('clearUserManager', 'LEAVING')
        dispatch('clearUserProfile')

        /* LEVA ATÉ A TELA DE LOGIN */
        if (window.location.pathname !== '/login') router.push('/login')
      }

      /**
       *
       *
       *
       * USUÁRIO LOGANDO
       *
       * DEBUG SESSION BEGIN
       *
       *
       *
       */

      else if (userJoin)
      {
        // console.log(`::: [${sessionEmail}] O USUÁRIO "${sessionUserID}" ENTROU DO GESTOR`)

        // console.log(`::: [${sessionEmail}] O USUÁRIO "${sessionUserID}" ENTROU DO GESTOR:`, { loadingGroups: state.loadingGroups, loadingUsers: state.loadingUsers })

        //
        // LEVA ATÉ A TELA INICIAL DO GESTOR (se necessário)
        //
        // SENHOR JESUS (levantar outras rotas)
        //

        if (window.location.pathname === '/' || window.location.pathname === '/login') router.push('/admin/grupos')

        dispatch('setUserGroupsStatus', 'WAITING')

        //
        // CONSULTANDO O PERFIL DO USUÁRIO NO BACK-END LÁRAVEL:
        //
        // + PLANOS
        // + PLANO CONTRATADO
        // + PERMISSÕES/CAPACIDADES
        // + CONSULTA O PERFIL DO USUÁRIO NO FIREBASE
        //

        // console.log(`::: [${sessionEmail}] CARREGANDO CAPACIDADES DO USUÁRIO...`)

        const uCapabilities = await getUserCapabilities({ userID: sessionUserID, userToken })

        // console.log(`::: [${sessionEmail}] RESPOSTA DAS CAPACIDADES DO USUÁRIO:`, uCapabilities)

        // [Senhor Jesus] Validação dos dados carregados do back-end em laravel

        if (uCapabilities.code === 'ERROR_PROFILE_API') {
          state.userSession.authState = 'DONE'
          dispatch('clearUserGroups', 'ERROR_PROFILE_API')
          return false
        }

        if (uCapabilities.code === 'ERROR_PLANS_API') {
          state.userSession.authState = 'DONE'
          dispatch('clearUserGroups', 'ERROR_PLANS_API')
          return false
        }

        commit('setPlans', uCapabilities.plans)

        //
        // AQUI COMEÇA O ACOMPANHAMENTO EM TEMPO REAL DO USUÁRIO (LOGADO). ESSE ACOMPANHAMENTO SERÁ ENCERRADO DURANTE O LOGOUT.
        //

        if (!!state.listeners.user === true) {
          state.userSession.authState = 'DONE'
          // console.log(`::: [${sessionEmail}] O ACOMPANHAMENTO DE DADOS DO PERFIL JÁ FOI INICIADO!`)
          return false
        }

        // console.log(`::: [${sessionEmail}] INICIANDO ACOMPANHAMENTO DE DADOS DO PERFIL...`)

        //
        //
        //
        // SINALIZA (PARA AS TELAS) QUE OS GRUPOS ESTÃO SENDO CARREGADOS
        // OBS: Se isso fosse feito dentro do onUserUpdate, as telas iam mostrar CARREGAMENTO toda vez que o usuário logado tivesse alguma alteração no banco de dados
        //
        //
        //

        state.loadingGroups = 'LOADING'

        //
        //
        //
        // À PARTIR DAQUI OS DADOS SERÃO PROCESSADOS SEMPRE QUE HOUVER UMA ALTERAÇÃO (NO PERFIL DO USUÁRIO LOGADO) NO REALTIME DATABASE
        //
        // SENHOR JESUS:
        // + CARREGAR GRUPOS E USUÁRIOS DO EDITOR "DE FORMA ESTÁTICA" ?
        //
        //
        //

        // REFERÊNCIA DO LISTENER
        state.listeners.user = firebase.database().ref(`users/${sessionUserID}`)

        state.listeners.onUserUpdate = async function (snapshot)
        {
          // DEBUG
          // console.log(`::: [${sessionEmail}] onUserUpdate[response]:`, uCapabilities)

          // PREPARA OS DADOS DO PERFIL PARA A VALIDAÇÃO (MAIS A FRENTE)
          const userUpdate = !!snapshot === true && !!snapshot.val() === true ? snapshot.val() : false

          // DEBUG
          // console.log(`::: [${sessionEmail}] DADOS DO PERFIL ATUALIZADOS NO BANCO DE DADOS:`, userUpdate)

          //
          // VERIFICA SE O "userUpdate" É VÁLIDO
          // SENHOR JESUS
          //

          const validUser = userUpdate && typeof userUpdate === 'object'

          if (!validUser) {
            state.userSession.authState = 'DONE'
            dispatch('clearUserGroups', 'ERROR_PROFILE_NOT_FOUND')
            return false
          }

          // SENHOR JESUS (VERIFICAR POSSÍVEL SOBRESCRITA DE DADOS / SEPARAR DADOS DA SESSSÃO E DADOS DO REALTIME DATABASE)
          // SENHOR JESUS (VERIFICAR SITUAÇÃO DOS DADOS DE PAGAMENTO / BACK-END)

          //
          //
          //
          // COLOCA OS DADOS NA STORE
          //
          //
          //

          const img = Object.prototype.hasOwnProperty.call(userUpdate, 'img') && isValidImage(userUpdate.img || '') ? String(userUpdate.img).trim() : userProfileBroken
          const nome = Object.prototype.hasOwnProperty.call(userUpdate, 'nome') && String(userUpdate.nome).trim().length > 0 ? String(userUpdate.nome) : ''
          const email = Object.prototype.hasOwnProperty.call(userUpdate, 'email') && String(userUpdate.email).trim().length > 0 ? String(userUpdate.email) : ''
          const ddd = Object.prototype.hasOwnProperty.call(userUpdate, 'ddd') && String(userUpdate.ddd).trim().length > 0 ? String(userUpdate.ddd).trim() : ''
          const tel = Object.prototype.hasOwnProperty.call(userUpdate, 'tel') && String(userUpdate.tel).trim().length > 0 ? String(userUpdate.tel).trim() : ''
          const phone = ddd.length === 2 && (tel.length === 8 || tel.length === 9) ? `(${ddd}) ${tel.replace(tel.length === 8 ? /(\d{4})(\d{4})/ : /(\d{5})(\d{4})/, '$1-$2')}` : ''
          const cpf = Object.prototype.hasOwnProperty.call(userUpdate, 'cpf') && String(userUpdate.cpf).trim().length > 0 ? String(userUpdate.cpf) : ''
          const cnpj = Object.prototype.hasOwnProperty.call(userUpdate, 'cnpj') && String(userUpdate.cnpj).trim().length > 0 ? String(userUpdate.cnpj) : ''
          const crm = Object.prototype.hasOwnProperty.call(userUpdate, 'crm') && String(userUpdate.crm).trim().length > 0 ? String(userUpdate.crm) : ''
          const conta = Object.prototype.hasOwnProperty.call(userUpdate, 'conta') && String(userUpdate.conta).trim().length > 0 ? String(userUpdate.conta) : ''
          const capsLock = userUpdate?.capsLock || false

          const userGroups = !!userUpdate.grupos === true && typeof userUpdate.grupos === 'object' ? Object.entries(userUpdate.grupos) : []
          const hasGroups = userGroups.length > 0

          // DEBUG
          // console.log(`::: [${sessionEmail}] isLoggedIn:`, isLoggedIn, sessionUserID)

          state.userSession = {
            loading: false, // Senhor Jesus
            authState: 'DONE',

            loggedIn: isLoggedIn,
            uid: sessionUserID,
            // displayName: sessionUserName,
            email: sessionEmail,
            userToken,

            userProfile: { img, nome, email, ddd, tel, phone, cpf, cnpj, crm, conta, capsLock },

            userGroupsAmount: userGroups.length,

            // SENHOR JESUS - Continuar aqui e também voltar para o state.user =
            planId: Number(uCapabilities.message.planId),
            planName: uCapabilities.message.planName,
            planCategory: uCapabilities.message.planCategory,
            planOrigin: uCapabilities.message.planOrigin,
            userCapabilities: uCapabilities.message.userCapabilities,

            vindi: uCapabilities.message.vindi,
            coupon: uCapabilities.message.coupon,
            groups: userUpdate.grupos,
          }

          // DEBUG
          // console.log(`::: [${sessionEmail}] DADOS DO PERFIL ATUALIZADOS NO VUEX:`, state.userSession)

          const gid = !!state.group === true && !!state.group.groupID === true ? state.group.groupID : null
          state.currentGroupCapabilities = processUserGroupCapabilities(userUpdate.grupos || null, gid)

          commit('SORT_GROUP_USERS')

          //
          //
          //
          // SE O USUÁRIO NÃO TIVER GRUPOS PARA PROCESSAR ENTÃO TERMINA O CARREGAMENTO INICIAL AQUI
          //
          //
          //

          if (!hasGroups)
          {
            state.userSession.authState = 'DONE'

            // FECHA OS LISTENERS DE GRUPOS E USUÁRIOS
            dispatch('clearUserGroups', 'NOT_FOUND')

            // SINALIZA PARA A PÁGINA DE EDITOR DE USUÁRIOS QUE NÃO HÁ GRUPOS
            dispatch('clearUserManager', 'NOT_FOUND')

            // DEBUG
            // console.log(`::: [${sessionEmail}] NÃO HÁ GRUPOS PARA PROCESSAR!`)

            return false
          }

          //
          //
          //
          // [PROCESSAMENTO DA LISTA DE GRUPOS COMEÇA AQUI]
          //
          // PROCESSAR OS GRUPOS DO USUÁRIO:
          //
          // - Apenas grupos do tipo "public"
          // - Apenas grupos que o usuário logado gerencia
          // - Esses dados serão usados principalmente na página "grupos" e depois na página "usuários"
          // - Também serão úteis para evitar recarregamento de dados nas diversas telas ao longo da navegação
          //
          //
          //

          // DEBUG
          // console.log(`::: [${sessionEmail}] PROCESSANDO ${userGroups.length} GRUPOS...`)

          const groupStatuses = await Promise.all(
            userGroups.map(async ([groupID, group]) => {
              // const group = userUpdate.grupos[groupID]

              // O USUÁRIO LOGADO É GESTOR DO GRUPO? CARREGA OS DADOS DO GRUPO...
              const groupData = !!group.admin === true ? await getGroupByID(groupID) : false

              // É GRUPO OU CHAT?
              const isValidGroup = !!groupData && !!groupData.type === true && groupData.type === 'public'

              const position = {
                listener: state.listeners.groups.findIndex(groupListener => groupListener.groupID === groupID),
                list: state.groups.findIndex(listItem => listItem.groupID === groupID),
              }

              // SOMA
              state.loadingGroupsProgress += 1

              return {
                groupID,
                status: isValidGroup ? 'valid' : 'invalid',
                operation: isValidGroup ? (position.listener !== -1 ? 'update' : 'add') : (position.listener !== -1 ? 'delete' : 'none'),
                position,
                data: groupData,
              }
            })
          )

          // DEBUG
          // console.log(`::: [${sessionEmail}] GRUPOS PROCESSADOS:`, groupStatuses)

          //
          //
          //
          // TERMINA AQUI SE O USUÁRIO LOGADO NÃO ESTIVER ADMINISTRANDO NO MÍNIMO UM GRUPO
          //
          //
          //

          const isThereAnyValidGroup = groupStatuses.some(item => item.status === 'valid')

          if (isThereAnyValidGroup === false)
          {
            state.userSession.authState = 'DONE'

            // FECHA OS LISTENERS DE GRUPOS E USUÁRIOS
            // SINALIZA QUE O CARREGAMENTO DE GRUPOS TERMINOU E NÃO TEM GRUPOS
            dispatch('clearUserGroups', 'NOT_ADMIN')

            // SINALIZA PARA A PÁGINA DE EDITOR DE USUÁRIOS QUE NÃO HÁ GRUPOS
            dispatch('clearUserManager', 'NOT_ADMIN')

            // DEBUG
            // console.log(`::: [${sessionEmail}] O USUÁRIO NÃO ADMINISTRA GRUPOS:`, groupStatuses)

            return false
          }

          //
          //
          //
          // DISPONIBILIZA LISTA DE GRUPOS PARA APARECER NA TELA PRINCIPAL
          //
          // SENHOR JESUS:
          // + Retirar carregamentos das telas compartilháveis
          //
          //
          //

          if (router.currentRoute.name !== 'Ver escala através de link') dispatch('setUserGroups', groupStatuses)

          //
          //
          //
          // [PROCESSAMENTO DO EDITOR DE USUÁRIOS COMEÇA AQUI]
          //
          // PROCESSAR USUÁRIOS DE TODOS OS GRUPOS ADMINISTRADOS PELO USUÁRIO LOGADO
          //
          // SENHOR JESUS - Nota:
          // + Limpar grupos/usuarios quando atualizar user/{user_id}
          // + Testar entrada/saida de grupos -> remoção ou inclusão de usuários
          //
          //
          //

          // Jesus: Solução para recarregamento da lista de grupos na tela?
          if (state.loadingUsers === 'WAITING') state.loadingUsers = 'LOADING'

          // const currentID = !!state.userSession === true && !!state.userSession.uid === true ? state.userSession.uid : false

          let groupsUsers = []

          groupStatuses.forEach(userGroup => {
            //
            // Jesus: Observar essa condicional
            //

            if (userGroup.status === 'valid' && (userGroup.operation === 'add' || userGroup.operation === 'update'))
            {
              const users = !!userGroup.data === true && !!userGroup.data.users === true && typeof userGroup.data.users === 'object' ? Object.keys(userGroup.data.users) : []

              if (users.length > 0)
              {
                const groupDetails = {
                  groupID: userGroup.groupID,
                  groupImage: isValidImage(userGroup.data.img || '') ? String(userGroup.data.img).trim() : groupplaceholder,
                  groupName: !!userGroup.data.nome === true ? String(userGroup.data.nome).trim() : userGroup.groupID,
                }

                users.forEach(userID => {
                  const userIndex = groupsUsers.findIndex(findUser => findUser.userID === userID)

                  // O EDITOR DE USUÁRIOS VAI MOSTRAR APENAS OS GRUPOS EM COMUM E ADMINISTRADOS PELO USUÁRIO LOGADO
                  if (userIndex === -1) {
                    // const user = getters.getUserById(userID) || null
                    groupsUsers.push({ isMe: userID === sessionUserID, userID, user: null, userGroups: [groupDetails] })
                  } else {
                    groupsUsers[userIndex].userGroups = [...groupsUsers[userIndex].userGroups, groupDetails]
                  }
                })
              }
            }
          })

          //
          // TOTAL DE USUÁRIOS EXISTENTES
          //

          state.loadingUsersMax = groupsUsers.length

          //
          // CARREGA PERFIL DE CADA USUÁRIO EXISTENTE
          //
          // NOTA:
          // AQUELES USUÁRIOS QUE JÁ FORAM CARREGADOS DO FIREBASE, NÃO PRECISAM SER RECARREGADOS...
          //

          groupsUsers = (await Promise.all(groupsUsers.map(async groupUser => {
            //
            //
            //

            const foundCachedUser = getters.getCachedUserById(groupUser.userID) || null
            const user = !!groupUser.user === false ? (!!foundCachedUser === true ? foundCachedUser : await getUserByID(groupUser.userID)) : null
            if (!!groupUser.user === false && !!foundCachedUser === false && !!user === true) commit('ADD_CACHED_USER', { userID: groupUser.userID, source: 'setAuthState', ...user })

            // console.log(foundCachedUser ? '::: GROUP USERS > LOADED FROM CACHE:' : '::: GROUP USERS > LOADED FROM FIREBASE:', groupUser.userID)

            //
            //
            //

            const userProfile = !!user === true ? processUserProfile(user) : false

            state.loadingUsersProgress += 1

            // img: userProfile.img, // Senhor Jesus
            // ddd: userProfile.ddd,

            if (!!groupUser.user === false && !!userProfile === true)
            {
              groupUser.user = {
                userID: groupUser.userID,
                email: userProfile.email,
                nome: userProfile.userName,
                nomeAbreviado: userProfile.userNameAbrev,
                img: userProfile.img,
                crm: userProfile.crm,
                cpf: userProfile.cpf,
                cnpj: userProfile.cnpj,
                tel: userProfile.telefone,
                conta: userProfile.conta,
                grupos: userProfile.grupos,
              }
            }

            return groupUser
          }))).filter(groupUser => !!groupUser === true && !!groupUser.user === true)

          // console.log(`::: [${sessionEmail}] GRUPOS PROCESSADOS > USUÁRIOS:`, groupsUsers)

          // const userGroups = !!state.userSession === true && !!state.userSession.groups === true ? state.userSession.groups : null
          // state.currentGroupCapabilities = processUserGroupCapabilities(state.userSession, state.group)

          state.managerUsers = groupsUsers

          state.loadingUsers = 'LOADED'
          state.loadingUsersProgress = 0
          state.loadingUsersMax = 0
        }

        //
        //
        //
        // INICIALIZA LISTENER DO PERFIL DO USUÁRIO LOGADO PARA O FIREBASE REALTIME DATABASE
        //
        //
        //

        apiRefOpen(state.listeners.user, state.listeners.onUserUpdate)
      }

      else
      {
        state.userSession.authState = 'DONE'

        // console.log(`[${sessionOrigin}] setAuthState: UNKNOWN`, state.userSession)
      }
    },

    //
    //
    //

    loadGroupPage ({ commit, dispatch, state, getters }, groupID = false) {
      if (!groupID && groupID !== 'clear') return

      if (
        groupID !== 'clear' &&
        groupID !== 'clear_group' &&
        state.listeners.groupRef !== null &&
        state.listeners.groupRef.key &&
        state.listeners.groupRef.key === groupID
      ) {
        // console.log(`::: O GRUPO "${groupID}" JÁ FOI CARREGADO, NÃO PRECISA CARREGAR O LISTENER`)
        return
      }

      /**
       *
       * FINALIZAR CARREGAMENTO DOS DADOS DO USUÁRIO LOGADO (SE EXISTIR)
       *
       */

      // SENHOR JESUS (SÓ FINALIZA ATUALIZAÇÕES DE USUÁRIO QUANDO SAI DO GESTOR? COMO ISSO IMPACTA ATUALIZAÇÕES DOS DETALHES DE ALGUM GRUPO?)

      if (state.listeners.user !== null && groupID === 'clear') {
        // console.log(`::: DESLIGANDO CARREGAMENTO DOS DETALHES DO USUÁRIO "${state.listeners.user ? state.listeners.user.key : 'DESCONHECIDO'}"`, state.listeners.user)

        apiRefClose(state.listeners.user, state.listeners.onUserUpdate)
        state.listeners.user = null
      }

      /**
       *
       * FINALIZAR CARREGAMENTO DOS DADOS NA PÁGINA DO GRUPO (SE EXISTIR)
       *
       */

      if (state.listeners.groupRef !== null) {
        // [24/01/25] console.log('::: DESLIGANDO groupRef:', groupID)

        apiRefClose(state.listeners.groupRef, state.listeners.onGroupUpdate)
        state.listeners.groupRef = null
      }

      if (state.listeners.groupScalesRef !== null) {
        // [24/01/25] console.log('::: DESLIGANDO groupScalesRef:', groupID)

        apiRefClose(state.listeners.groupScalesRef, state.listeners.onGroupScalesUpdate)
        state.listeners.groupScalesRef = null
      }

      if (state.listeners.groupRequestedShiftsRef !== null) {
        // [24/01/25] console.log('::: DESLIGANDO groupRequestedShiftsRef:', groupID)

        apiRefClose(state.listeners.groupRequestedShiftsRef, state.listeners.onGroupRequestedShiftsUpdate)
        state.listeners.groupRequestedShiftsRef = null
      }

      commit('CLEAR_GROUP')

      state.groupScales = []
      state.listeners.groupScales = []

      /**
       *
       * INICIALIZAR CARREGAMENTO DOS DADOS NA PÁGINA DO GRUPO
       *
       */

      if (groupID !== 'clear' && groupID !== 'clear_group')
      {
        //
        //
        //
        //
        //
        //
        //
        //
        //
        // [GRUPO] DETALHES
        //
        //
        //
        //
        //
        //
        //
        //
        //

        if (!!state.listeners.groupRef === false)
        {
          // [24/01/25] console.log(`::: [${groupID}] [groupRef] CARREGANDO "GRUPO"`)

          state.listeners.loadingGroupDetails = 'yes'
          state.listeners.groupRef = firebase.database().ref(`grupos/${groupID}`)

          state.listeners.onGroupUpdate = async function (snapshot)
          {
            const group = !!snapshot === true && !!snapshot.val() === true ? snapshot.val() : false
            if (!!group === false) return false

            // SET GROUP DATA
            commit('SET_GROUP', processGroupSettings(snapshot.key, group))

            // QUANTIDADE DE USUÁRIOS DO GRUPO
            const groupUsersKeys = !!group === true || typeof group === 'object' || !!group.users === true || typeof group.users === 'object' ? Object.keys(group.users) : []

            // ATUALIZA ESTATÍSTICAS DO GRUPO
            commit('SET_GROUP_STATISTICS', { availableShiftsCount: false, ownedShiftsCount: false, participantsCount: groupUsersKeys.length })

            //
            // LISTA DE USUÁRIOS DO GRUPO (PARA OS DETALHES DO GRUPO)
            //

            // JESUS > Bug antigo: Pode acontecer do userSession carregar depois do grupo e por isso a lista não é reordenada corretamente
            // const currentID = !!state.userSession === true && !!state.userSession.uid === true ? state.userSession.uid : false

            const usersList = groupUsersKeys.length > 0 ? await Promise.all(
              groupUsersKeys.map(async userID => {
                // LOAD USER PROFILE
                const foundCachedUser = getters.getCachedUserById(userID) || null
                const uProfile = !!foundCachedUser === true ? foundCachedUser : await getUserByID(userID)
                if (!!foundCachedUser === false) commit('ADD_CACHED_USER', { userID, source: 'onGroupUpdate', ...uProfile })

                // PROCESSED USER PROFILE
                return processGroupUserProfile(snapshot.key, userID, /* currentID, */ uProfile, group)
              }).filter(usuario => !!usuario === true && typeof usuario === 'object')
            ) : []

            //
            // JESUS
            //
            // As vezes não funciona:
            // F5 após SAVE no vscode com WATCH ativado? ou F5 em qualquer situação ?
            //

            commit('SET_GROUP_USERS', { groupID, users: usersList })
            commit('SORT_GROUP_USERS')

            state.listeners.loadingGroupDetails = 'no'

            //
            // DEBUG
            //

            // [24/01/25] console.log(`::: [${groupID}] [onGroupUpdate] PARTICIPANTES:`, groupUsersKeys.length)
          }

          apiRefOpen(state.listeners.groupRef, state.listeners.onGroupUpdate)
        }

        //
        //
        //
        //
        //
        //
        //
        //
        //
        // [GRUPO] ESCALAS
        //
        //
        //
        //
        //
        //
        //
        //
        //

        if (!!state.listeners.groupScalesRef === false)
        {
          // [24/01/25] console.log(`::: [${groupID}] [groupScalesRef] CARREGANDO "ESCALAS DO GRUPO"`)

          state.listeners.loadingGroupScales = 'yes'
          state.listeners.groupScalesRef = firebase.database().ref(`escalas/${groupID}`)

          state.listeners.onGroupScalesUpdate = function (snapshot)
          {
            const rawScales = !!snapshot === true && !!snapshot.val() === true ? Object.entries(snapshot.val()) : []

            // ATUALIZANDO A LISTA DE PLANTÕES SINALIZADOS
            // dispatch('RELOAD_GROUP_WAITING_DUTIES', groupID)

            const processedScales = rawScales.length > 0 ? processGroupScales(rawScales) : null
            const groupScales = !!processedScales === true ? processedScales.groupScales : []
            const numberOfPlantonistasOnGroup = !!processedScales === true ? processedScales.numberOfPlantonistasOnGroup : 0

            state.groupScales = groupScales
            state.listeners.groupScales = groupScales
            state.listeners.numberOfPlantonistasOnGroup = numberOfPlantonistasOnGroup
            state.listeners.loadingGroupScales = 'no'

            // [24/01/25] console.log(`::: [${groupID}] [onGroupScalesUpdate] ESCALAS DO GRUPO ATUALIZADAS (+ ESTATÍSTICAS):`, !!processedScales === true ? processedScales.groupScales.length : 0)
          }

          apiRefOpen(state.listeners.groupScalesRef, state.listeners.onGroupScalesUpdate)
        }

        //
        //
        //
        //
        //
        //
        //
        //
        //
        // [GRUPO] PLANTÕES SINALIZADOS (SOLICITADOS)
        //
        //
        //
        //
        //
        //
        //
        //

        if (!!state.listeners.groupRequestedShiftsRef === false)
        {
          // [24/01/25] console.log(`::: [${groupID}] [groupRequestedShiftsRef] CARREGANDO "PLANTÕES SOLICITADOS"`)

          state.listeners.loadingRequestedShifts = 'yes'
          state.listeners.groupRequestedShiftsRef = firebase.database().ref('plantoes_sinalizados').orderByChild('dutyGroupID').equalTo(groupID)

          state.listeners.onGroupRequestedShiftsUpdate = async function (snapshot)
          {
            const waitingDutiesFb = snapshot && snapshot.val() ? snapshot.val() : false
            const waitingDutiesKeys = !!waitingDutiesFb === true || typeof waitingDutiesFb === 'object' ? Object.keys(waitingDutiesFb) : []

            if (waitingDutiesKeys.length === 0)
            {
              commit('SET_GROUP_WAITING_DUTIES', [])
            }
            else
            {
              // USUÁRIO LOGADO
              const currentID = !!state.userSession === true && !!state.userSession.uid === true ? state.userSession.uid : false

              // PROCESS LOADED "REQUESTED SHIFTS"
              const waitingDutiesList = waitingDutiesKeys.length > 0 ? await Promise.all(
                waitingDutiesKeys.map(async waitingDutyID => {
                  // REQUESTED SHIFT OBJECT
                  const waitingDuty = waitingDutiesFb[waitingDutyID]

                  // REQUESTED SHIFT CREATOR PROFILE
                  const foundCachedUser = getters.getCachedUserById(waitingDuty.dutyCreatorID) || null
                  const dutyCreatorProfile = !!foundCachedUser === true ? foundCachedUser : await getUserByID(waitingDuty.dutyCreatorID)
                  if (!!foundCachedUser === false) commit('ADD_CACHED_USER', { userID: waitingDuty.dutyCreatorID, source: 'onGroupRequestedShiftsUpdate', ...dutyCreatorProfile })

                  // REQUESTED SHIFT SCALE
                  const dutyScale = await getScaleByID(waitingDuty.dutyGroupID, waitingDuty.dutyScaleID)

                  // FORMAT AND OUTPUT
                  return buildRequestedShiftObj(dutyCreatorProfile, waitingDutyID, waitingDuty, dutyScale, currentID)
                }).filter(dutyCheck => !!dutyCheck === true && typeof dutyCheck === 'object')
              ) : []

              // ORDENA LISTA (ASC)
              if (waitingDutiesList.length > 0) waitingDutiesList.sort((a, b) => a.dutyWaitingListDateCompare - b.dutyWaitingListDateCompare)

              // ATUALIZA LISTA
              commit('SET_GROUP_WAITING_DUTIES', waitingDutiesList)
            }
          }

          //
          //
          //

          apiRefOpen(state.listeners.groupRequestedShiftsRef, state.listeners.onGroupRequestedShiftsUpdate)
        }
      }
    },

    //
    //
    //
    // QUANDO ATUALIZA OS DADOS DO USUÁRIO (Ex: NOME, GRUPOS...) A LISTA DE GRUPOS (CARREGADA) SERÁ COMPARADA COM A LISTA DE GRUPOS (NA STORE) E AS DIFERENÇAS APLICADAS
    //
    // Caminho no realtime database: /users/${userID}
    //
    //
    //

    setUserGroups: (context, newGroupList) => {
      const newOrUpdatedGroups = []
      const inactiveGroups = []

      // SENHOR JESUS
      context.state.loadingGroups = 'LOADED'
      context.state.loadingGroupsProgress = 0

      /**
       *
       * TRATA GRUPOS QUE SERÃO ADICIONADOS OU APAGADOS
       *
       */

      newGroupList.forEach(newGroup => {
        /**
         *
         * COLOCA O GRUPO NA LISTA QUE VAI APARECER NA TELA
         * Condição: UM NOVO GRUPO ou GRUPO JÁ EXISTIA NA STORE
         *
         */

        if (newGroup.operation === 'add' || newGroup.operation === 'update')
        {
          // console.log(`::: ADICIONANDO GRUPO "${newGroup.groupID}"...`)

          // COLOCA GRUPO NO ARRAY DE GRUPOS QUE VÃO APARECER NA TELA
          newOrUpdatedGroups.push(buildGroupObject(newGroup.groupID, newGroup.data))
        }

        /**
         *
         * O GRUPO NÃO EXISTE NA STORE?
         * INICIA ACOMPANHAMENTO DE DADOS DO GRUPO EM TEMPO REAL
         *
         */

        // [24/01/25] console.log('::: setUserGroups:', window.location.pathname)
        // [24/01/25] console.log('newGroup:', newGroup)

        if (newGroup.operation === 'add' && (window.location.pathname === '/admin/grupos/' || window.location.pathname === '/admin/grupos'))
        {
          // [24/01/25] console.log('::: [setUserGroups] Acompanhar grupo em tempo real:', newGroup)

          context.state.listeners.groups.push({
            ref: firebase.database().ref(`grupos/${newGroup.groupID}`),

            groupID: newGroup.groupID,

            // SENHOR JESUS
            // O QUE ACONTECE SE O USUÁRIO DEIXAR DE SER ADMIN DO GRUPO PELO APP? DISPARA DOIS UPDATES?)

            listener: function (groupSnapshot)
            {
              const groupUpdate = groupSnapshot && groupSnapshot.val() ? groupSnapshot.val() : false

              if (!!groupUpdate === true) context.commit('UPDATE_GROUP_ITEM', buildGroupObject(groupSnapshot.key, groupUpdate))
            },
          })

          const foundGroupListener = context.state.listeners.groups.find(group => group.groupID === newGroup.groupID)

          apiRefOpen(foundGroupListener.ref, foundGroupListener.listener)
        }

        /**
         *
         * RETIRA O GRUPO DA LISTA
         * ENCERRA O ACOMPANHAMENTO DE DADOS EM TEMPO REAL
         *
         */

        if (newGroup.operation === 'delete')
        {
          // console.log(`::: APAGANDO GRUPO "${newGroup.groupID}"...`)

          //
          // COLOCA NA LISTA DE GRUPOS INATIVOS

          inactiveGroups.push(newGroup.groupID)

          //
          // SE O USUÁRIO ESTIVER EM ALGUMA ROTA COM ESSE GRUPO, SAI DELA

          if (window.location.pathname.indexOf(newGroup.groupID) !== -1) {
            // console.log(`::: O GRUPO "${newGroup.groupID}" SERÁ APAGADO DA LISTA DE GRUPOS, MOVENDO PARA A TELA DE GRUPOS...`)
            // console.log(`::: VOCÊ NÃO FAZ MAIS PARTE DO GRUPO "${newGroup.groupID}", MOVENDO PARA A TELA DE GRUPOS...`)
            router.push('/admin/grupos')
          }

          //
          // RETIRA O GRUPO DA LISTA DE GRUPOS (que aparecem na tela)

          if (context.state.groups.length === 1) {
            context.state.groups = []
          } else {
            //
            //
            // APAGAR
            context.state.groups.splice(newGroup.position.list, 1)
            // ORDENAR
            context.state.groups.sort((a, b) => a.groupName.localeCompare(b.groupName))
          }

          //
          // ENCERRA O ACOMPANHAMENTO DE DADOS EM TEMPO REAL
          //

          if (context.state.listeners.groups.length > 0)
          {
            apiRefClose(context.state.listeners.groups[newGroup.position.listener].ref, context.state.listeners.groups[newGroup.position.listener].listener)

            if (context.state.listeners.groups.length === 1) {
              context.state.listeners.groups = []
            } else {
              context.state.listeners.groups.splice(newGroup.position.listener, 1)
            }
          }
        }
      })

      /**
       *
       * TRATA GRUPOS APAGADOS
       *
       */

      if (inactiveGroups.length > 0)
      {
        // console.log(':::: GRUPOS APAGADOS DA TELA (+ ACOMPANHAMENTO ENCERRADO):', inactiveGroups)

        //
        // ENCERRA ATUALIZAÇÕES (EM TEMPO REAL) DE UM GRUPO QUE FOI OU ESTÁ ABERTO, MAS ESTÁ DESATIVADO

        if (!!context.state.group && !!context.state.group.groupID)
        {
          if (inactiveGroups.indexOf(context.state.group.groupID) !== -1)
          {
            // console.log(`::: O GRUPO "${context.state.group.groupID}" FOI APAGADO DA LISTA, DESATIVANDO ALTERAÇÕES EM TEMPO REAL DESSE GRUPO...`)
            context.dispatch('loadGroupPage', 'clear_group')
          }
          else
          {
            //
          }
        }
        else
        {
          // console.log('::: NÃO FOI POSSÍVEL DESATIVAR ALTERAÇÕES EM TEMPO REAL:', context.state.group)
        }
      }

      //
      // MOSTRA GRUPOS NA TELA, SEM ESPERAR PELO ACOMPANHAMENTO EM TEMPO REAL DE CADA GRUPO
      //

      if (newOrUpdatedGroups.length > 0) context.dispatch('setScreenGroups', newOrUpdatedGroups)
    },

    //
    // INICIA ACOMPANHAMENTO DE DADOS DOS GRUPOS
    //

    startUserGroupsListeners: (context) => {
      // [24/01/25] console.log('::: startUserGroupsListeners:', window.location.pathname)

      if (
        // window.location.pathname !== '/admin/grupos/' ||
        context.state.groups.length === 0 ||
        context.state.loadingGroups !== 'LOADED' ||
        (context.state.loadingGroups === 'LOADED' && context.state.groups.length === 0)
      ) return false

      context.state.groups.forEach(groupItem => {
        if (!context.state.listeners.groups.some(listenerGroup => listenerGroup.groupID === groupItem.groupID))
        {
          // [24/01/25] console.log('::: [startUserGroupsListeners] Acompanhar grupo em tempo real:', groupItem.groupID)

          context.state.listeners.groups.push({
            ref: firebase.database().ref(`grupos/${groupItem.groupID}`),

            groupID: groupItem.groupID,

            // SENHOR JESUS
            // O QUE ACONTECE SE O USUÁRIO DEIXAR DE SER ADMIN DO GRUPO PELO APP? DISPARA DOIS UPDATES?)

            listener: function (groupSnapshot)
            {
              const groupUpdate = groupSnapshot && groupSnapshot.val() ? groupSnapshot.val() : false

              if (!!groupUpdate === true) context.commit('UPDATE_GROUP_ITEM', buildGroupObject(groupSnapshot.key, groupUpdate))
            },
          })

          const foundGroupListener = context.state.listeners.groups.find(group => group.groupID === groupItem.groupID)

          apiRefOpen(foundGroupListener.ref, foundGroupListener.listener)
        }
      })
    },

    //
    // PARA ACOMPANHAMENTO DE DADOS DOS GRUPOS
    //

    stopUserGroupsListeners: (context) => {
      // [24/01/25] console.log('::: stopUserGroupsListeners:', window.location.pathname)

      if (
        // window.location.pathname !== '/admin/grupos/' ||
        context.state.listeners.groups.length === 0 ||
        context.state.groups.length === 0 ||
        context.state.loadingGroups !== 'LOADED' ||
        (context.state.loadingGroups === 'LOADED' && context.state.groups.length === 0)
      ) return false

      context.state.listeners.groups.forEach(groupListener => {
        if (groupListener.groupID) {
          // [24/01/25] console.log('::: [stopUserGroupsListeners] Parou acompanhamento do grupo em tempo real:', groupListener.groupID)
          apiRefClose(groupListener.ref, groupListener.listener)
        }
      })

      context.state.listeners.groups = []
    },

    //
    //
    //

    setScreenGroups: (context, groups) => {
      context.commit('SET_SCREEN_GROUPS', groups)
    },

    setUserGroupsStatus: (context, loading) => {
      context.commit('SET_USER_GROUPS_STATUS', loading)
    },

    clearUserGroups: (context, loading) => {
      context.commit('CLEAR_USER_GROUPS', loading)
    },

    clearUserManager: (context, loading) => {
      context.commit('CLEAR_USER_MANAGER', loading)
    },

    clearUserProfile: context => {
      context.commit('CLEAR_USER_PROFILE')
    },
  },
})

export default store
